/**
 * Role Impersonation Service
 * Frontend service for role mocking/impersonation API calls
 */

import api from "./api";

const roleImpersonationService = {
  /**
   * Start impersonating a role
   * @param {string} mockRole - Role to impersonate
   * @returns {Promise} API response with new token
   */
  async startImpersonation(mockRole) {
    const response = await api.post("/api/role-impersonation/start", {
      mockRole,
    });

    // Update stored token if new token is provided
    if (response.data.data && response.data.data.token) {
      localStorage.setItem("token", response.data.data.token);
    }

    return response;
  },

  /**
   * Exit impersonation and return to original role
   * @returns {Promise} API response with original token
   */
  async exitImpersonation() {
    const response = await api.post("/api/role-impersonation/exit");

    // Update stored token
    if (response.data.data && response.data.data.token) {
      localStorage.setItem("token", response.data.data.token);
    }

    return response;
  },

  /**
   * Get current impersonation status
   * @returns {Promise} Status object
   */
  async getStatus() {
    return api.get("/api/role-impersonation/status");
  },

  /**
   * Get available roles for impersonation
   * @returns {Promise} List of available roles
   */
  async getAvailableRoles() {
    return api.get("/api/role-impersonation/available-roles");
  },
};

export default roleImpersonationService;
